import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";
import ServiceIntroCardSequence from "./interaction/interaction1";
import ServiceIntroCard2Sequence from "./interaction/interaction2";
import HomeHubCardsV4Responsive from "./interaction/interaction4";
import ServiceIntroCard3Sequence from "./interaction/intreaction3";

export const Section4 = () => {
  const isMobile = useResponsiveMobile(900);
  return (
    <section className="flex flex-col gap-[50px] md:gap-[100px] items-center justify-center px-[24px] w-full">
      <div className="flex flex-col md:flex-row w-full max-w-[1400px] gap-10 md:gap-[100px] items-center justify-center">
        <div className="flex flex-col gap-8 md:w-1/2 justify-center items-center md:items-start">
          <img
            src="/assets/images/serviceIntro/value1.png"
            alt="value"
            width={isMobile ? 36 : 56}
          />
          <div className="flex flex-col gap-6">
            <span className="font-bold text-[28px] md:text-display leading-[130%] text-center md:text-left">
              정확한 정산을,
              <br /> <span className="text-[#0079FF]"> 알아서 운영해주는 시스템</span>
            </span>
            <span className="font-normal text-[18px] md:text-heading1 text-[#4D4F58] leading-[130%] text-center md:text-left">
              분산된 채널의 데이터를 기준에 맞게 자동 반영해, <br />
              시간과 수작업에 의존하지 않는 정확한 정산을 {isMobile && <br />} 제공해요.
            </span>
          </div>
        </div>

        <div className="flex w-full md:w-1/2 items-center justify-center">
          {isMobile ? (
            <img src="/assets/images/serviceIntro/eg2.png" alt="eg" className="w-full h-auto" />
          ) : (
            <ServiceIntroCardSequence />
          )}
        </div>
      </div>
      <div className="flex flex-col md:flex-row max-w-[1400px] gap-10 md:gap-[100px] items-center w-full justify-center">
        {!isMobile && (
          <div className="flex md:flex-1 ">
            <ServiceIntroCard2Sequence />
          </div>
        )}
        <div className="flex md:flex-1 flex-col gap-8 justify-center items-center md:items-start">
          <img
            src="/assets/images/serviceIntro/value2.png"
            alt="value"
            width={isMobile ? 36 : 56}
          />
          <div className="flex flex-col gap-6">
            <span className="font-bold text-[28px] md:text-display leading-[130%] text-center md:text-left">
              다계층 영업조직을 위한
              <br /> <span className="text-[#0079FF]"> 영업지원 슈퍼어드민</span>
            </span>
            <span className="font-normal text-[18px] md:text-heading1 text-[#4D4F58] leading-[130%] text-center md:text-start">
              총판-대리점-딜러로 이어지는 복잡한 {isMobile && <br />}
              영업 구조 내에서도 <br /> 각 역할별 수수료 정책을 유연하게 적용하고 <br />
              권한 제어 및 실시간 성과 추적이 가능해요
            </span>
          </div>
        </div>
        {isMobile && (
          <div className="w-full flex justify-center items-center">
            <img src="/assets/images/serviceIntro/eg3.png" alt="eg" className="w-full h-auto" />
          </div>
        )}
      </div>
      <div className="flex-col flex md:flex-row w-full max-w-[1400px] gap-10 md:gap-[100px] items-center  justify-center">
        <div className="flex flex-col gap-8 md:flex-1 justify-center items-center md:items-start">
          <img
            src="/assets/images/serviceIntro/value3.png"
            alt="value"
            width={isMobile ? 36 : 56}
          />
          <div className="flex flex-col gap-6">
            <span className="font-bold text-[28px] md:text-display leading-[130%] text-center md:text-left">
              정산 솔루션 도입 및 <br />
              <span className="text-[#0079FF] ">유지비용 최소화</span>
            </span>
            <span className="font-normal text-[18px] md:text-heading1 text-[#4D4F58] leading-[130%] text-center md:text-left">
              별도의 인프라 구축이나 PG업 등록 없이, <br />
              SaaS 형태의 정산 솔루션을 <br />
              즉시 비즈니스에 적용하고 운영 부담을 {isMobile && <br />}
              최소화해요
            </span>
          </div>
        </div>
        {isMobile ? (
          <img src="/assets/images/serviceIntro/eg4.png" alt="eg" className="w-full h-auto" />
        ) : (
          <div className="flex md:flex-1">
            <ServiceIntroCard3Sequence />
          </div>
        )}
      </div>
      <div className="flex flex-col md:flex-row max-w-[1400px] gap-10 md:gap-[100px] items-center w-full justify-center">
        {!isMobile && (
          <>
            <div className="flex md:flex-1">
              <HomeHubCardsV4Responsive />
            </div>
          </>
        )}
        <div className="flex md:flex-1 flex-col gap-8 justify-center items-center md:items-start">
          <img
            src="/assets/images/introduction/linking_financing.png"
            alt="value"
            width={isMobile ? 36 : 56}
          />
          <div className="flex flex-col gap-6">
            <span className="font-bold text-[28px] md:text-display leading-[130%] text-center md:text-left">
              파이낸싱을 통한
              <br /> <span className="text-[#0079FF]"> 가맹점 상생 구조</span>
            </span>
            <span className="font-normal text-[18px] md:text-heading1 text-[#4D4F58] leading-[130%] text-center md:text-start">
              선/실시간 정산 및 매출 약정 지원 서비스를 통해 <br />
              가맹점의 자금 회전을 돕고 플랫폼의 <br /> 시장 지배력을 강화해요
            </span>
          </div>
        </div>
        {isMobile && (
          <div className="w-full flex justify-center items-center">
            <img src="/assets/images/serviceIntro/eg5.png" alt="eg" className="w-full h-auto" />
          </div>
        )}
      </div>
    </section>
  );
};
